module.exports = __webpack_public_path__ + "img/right-icon.fbcf88bd.jpg";